import { LegendMetadata } from '../../pricing-simulator/types/generic-table.model';

export default function LegendBox({
  legendMetadata
}: {
  legendMetadata: LegendMetadata;
}) {
  return (
    <div className='sku-legend-div' style={{ margin: 'auto' }}>
      <div
        className='sku-legend-box'
        style={{
          background: `${legendMetadata.color}`,
          marginTop: '4px'
        }}
      />
      <div className='legend-title' style={{ marginTop: '7px' }}>
        {legendMetadata.label}{' '}
      </div>
    </div>
  );
}
